module.exports = __webpack_public_path__ + "static/media/action-icon-buttons-outlined-32-black-right-arrow.570d9c4e.svg";